import { render, staticRenderFns } from "./PostPackageGroupView.vue?vue&type=template&id=b31d6e48&scoped=true"
import script from "./PostPackageGroupView.vue?vue&type=script&lang=js"
export * from "./PostPackageGroupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31d6e48",
  null
  
)

export default component.exports